var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "coupon-category-app-container",
      staticStyle: { position: "relative", height: "100%" },
    },
    [
      _vm.form.id && _vm.form.id > 0
        ? _c(
            "el-dialog",
            {
              attrs: {
                "append-to-body": "",
                title: _vm.form.categoryName + "子分類維護",
                width: "60%",
                visible: _vm.dialogSubVisible,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogSubVisible = $event
                },
              },
            },
            [
              _c("sub-Category", {
                attrs: {
                  "parent-id": _vm.form.id,
                  "parent-name": _vm.form.categoryName,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            title: _vm.funcName + "維護",
            visible: _vm.dialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": _vm.formLabelWidth },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.funcName + "名稱" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.categoryName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "categoryName", $$v)
                          },
                          expression: "form.categoryName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "狀態" } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": "停用",
                          "inactive-text": "啟用",
                          "active-color": "#ff4949",
                          "inactive-color": "#13ce66",
                          "active-value": true,
                          "inactive-value": false,
                        },
                        model: {
                          value: _vm.form.disabled,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "disabled", $$v)
                          },
                          expression: "form.disabled",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序", prop: "sort" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 1, label: "排序" },
                        model: {
                          value: _vm.form.sort,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "sort", $$v)
                          },
                          expression: "form.sort",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "子分類維護" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "success" },
                          on: { click: _vm.addSubCategory },
                        },
                        [_vm._v("維護子分類")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { color: "#4b4b4b" },
                  attrs: { type: "warning" },
                  on: { click: _vm.saveData },
                },
                [_vm._v("儲 存")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticClass: "filter-form",
          attrs: { inline: true },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "查詢" } },
            [
              _c("el-input", {
                attrs: { placeholder: "輸入分類" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.getList($event)
                  },
                },
                model: {
                  value: _vm.listQuery.qry,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "qry", $$v)
                  },
                  expression: "listQuery.qry",
                },
              }),
            ],
            1
          ),
          _c("el-button", {
            staticStyle: { "margin-top": "8px", "margin-left": "5px" },
            attrs: {
              type: "primary",
              icon: "el-icon-search",
              circle: "",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.getList },
          }),
          _c("el-button", {
            attrs: {
              type: "warning",
              circle: "",
              icon: "el-icon-plus",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.addData },
          }),
          _c("el-button", {
            staticStyle: { cursor: "pointer" },
            attrs: {
              type: "success",
              loading: _vm.listLoading,
              circle: "",
              icon: "el-icon-refresh-left",
            },
            on: {
              click: function ($event) {
                return _vm.refresh()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: _vm.funcName + "名稱" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.categoryName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: _vm.funcName + "排序",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.sort))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "狀態", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.disabled ? "danger" : "success",
                            },
                          },
                          [_vm._v(_vm._s(scope.row.disabled ? "停用" : "啟用"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "編輯", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [_vm._v("編輯")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "刪除", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteData(scope.row)
                              },
                            },
                          },
                          [_vm._v("刪除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }